/** True when the SPA is served from a local machine (dev). */
export function isLocalApp() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1";
}
